import { useApolloClient } from "@apollo/client";
import React from "react";
import { useUseMemberDefaultProjectRolesLazyQuery } from "./useMemberDefaultProjectRoles.generated.js";

export const useMemberDefaultProjectRoles = () => {
  const client = useApolloClient();
  const [fetch, query] = useUseMemberDefaultProjectRolesLazyQuery({
    client,
  });

  const fetchDefaultRoles = React.useCallback(
    async (memberId: string) => {
      const r = await fetch({ variables: { memberId } });
      return (
        r.data?.organisationMemberships.edges[0]?.node.defaultProjectRoles ?? []
      );
    },
    [fetch]
  );

  return fetchDefaultRoles;
};
